<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pySNsW/tc-custom/9781614751205.jpg?1721404571024" alt="This image is the cover for the book Ocean"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ocean
      </h1>
      <p class="bookDescription body article font2">
        <p><b>From a <i>New York Times</i>–bestselling author, an ecological thriller about human animal hybrids battling to rescue the ocean from environmental impact. </b></p><p> In 2024, Earth is consumed by a great War of Ocean Liberation: a military force of sea creatures attacks naval installations, shuts down shipping lanes and fishing operations, and destroys offshore oil-drilling rigs. Huge blue whales, sharks, dolphins, and even monstrous creatures thought to be extinct—all strike with ferocity and surprising strength. </p><p> The marine armada is led by hybrid, transformed humans who call themselves Sea Warriors, ocean-rights zealots who can swim to the deepest regions of the sea and live off the bounty of the waters. Their commander, Kimo Pohaku, announces his startling intention: The complete liberation of the seas from human control. </p><p> Finally, the ocean is fighting back, but it might be too late . . . </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brian Herbert, Jan Herbert
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Word Fire Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2ccde819